__turbopack_context__.v({
  "bottom": "style-module-scss-module__jtr7Pa__bottom",
  "brands": "style-module-scss-module__jtr7Pa__brands",
  "brandsIn": "style-module-scss-module__jtr7Pa__brandsIn",
  "brandsLabel": "style-module-scss-module__jtr7Pa__brandsLabel",
  "colHeading": "style-module-scss-module__jtr7Pa__colHeading",
  "colLink": "style-module-scss-module__jtr7Pa__colLink",
  "colList": "style-module-scss-module__jtr7Pa__colList",
  "copyright": "style-module-scss-module__jtr7Pa__copyright",
  "desc": "style-module-scss-module__jtr7Pa__desc",
  "footer": "style-module-scss-module__jtr7Pa__footer",
  "grid": "style-module-scss-module__jtr7Pa__grid",
  "legal": "style-module-scss-module__jtr7Pa__legal",
  "legalLink": "style-module-scss-module__jtr7Pa__legalLink",
  "logo": "style-module-scss-module__jtr7Pa__logo",
  "logoLink": "style-module-scss-module__jtr7Pa__logoLink",
  "social": "style-module-scss-module__jtr7Pa__social",
  "socialLink": "style-module-scss-module__jtr7Pa__socialLink",
});
